import { Box, Skeleton } from '@mui/material';
import React from 'react';

const HypothesesResumeLoader = (): React.ReactElement => (
    <>
        {[
            [180, 320],
            [160, 250],
            [140, 300],
        ].map(([titleWidth, contentWidth]) => (
            <Box key={`${titleWidth}-${contentWidth}`}>
                <Skeleton
                    variant="rectangular"
                    sx={{
                        height: 16,
                        width: titleWidth,
                        borderRadius: 4,
                        mb: '0.2rem',
                    }}
                />
                <Skeleton
                    variant="rectangular"
                    sx={{ height: 14, width: contentWidth, borderRadius: 4 }}
                />
            </Box>
        ))}
    </>
);

export default HypothesesResumeLoader;
